import script from "./PopupTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./PopupTemplate.vue?vue&type=style&index=0&id=7c7c227f&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c7c227f"]])

export default __exports__